module.exports = __webpack_public_path__ + "img/title-free.bafce488.png";